import { redirect } from "react-router-dom";
import { authService } from "@/services/auth/authService";

export const memberOnlyLoader = () => {
  if (!authService.getAccessToken()) {
    throw redirect("/login");
  }
  return null;
};
